import { createServerFn } from "@tanstack/react-start";

/** Public retail catalogue. Read-only; RLS applies as anon. */
export const listRetailPacksFn = createServerFn({ method: "GET" }).handler(async () => {
  const { listRetailPacks } = await import("./retail.server");
  try {
    return { packs: await listRetailPacks(), error: null as string | null };
  } catch (err) {
    return { packs: [], error: err instanceof Error ? err.message : "Failed to load retail packs" };
  }
});